import formStyles from "@/asserts/styles/formSection.module.less";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Table, TableColumnType } from "antd";
import clsx from "clsx";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import type { LowValuePurchaseRequisitionFormValue } from "../../type";
import styles from "./MaterialFormFields.module.less";
import { useNoMaterialCodeColumns } from "./hooks/useNoMaterialCodeColumns";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useTranslation } from "react-i18next";

export const NocodeMaterialFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");

  const [hoverIndex, setHoverIndex] = useState<number | null>(null);
  const form = Form.useFormInstance<LowValuePurchaseRequisitionFormValue>();

  const { isMainFormDisabled } = useFormEditable();

  const itemList = Form.useWatch(["itemList"], form) || [];

  const totalAmount = itemList.reduce((sum, item) => {
    if (item?.applyQty && item?.priceHkd) {
      return sum + Number(item.priceHkd) * Number(item.applyQty);
    }
    return sum;
  }, 0);

  const tableColumns = useNoMaterialCodeColumns();

  return (
    <div className={clsx(formStyles.formSection, styles.section)}>
      <ModalSectionHeader title={t("申请采购物品明细")} />

      <div className={styles.sectionBody}>
        <Form.List name="itemList">
          {(fields, { add, remove }) => {
            const indexColumn: TableColumnType = {
              title: t("序号"),
              dataIndex: "index",
              width: 80,
              align: "center",
              fixed: "left",
              render: (_, __, index) => {
                const isHover = hoverIndex === index && !isMainFormDisabled;
                return isHover ? (
                  <div
                    className={styles.removeIcon}
                    onClick={() => remove(index)}
                  >
                    <Trash2 size={20} />
                  </div>
                ) : (
                  index + 1
                );
              },
            };

            const columns = [indexColumn, ...tableColumns];

            return (
              <>
                <Table
                  bordered
                  dataSource={fields}
                  pagination={false}
                  scroll={{ x: 1600 }}
                  onRow={(_, index) => ({
                    onMouseEnter: () => setHoverIndex(index!),
                    onMouseLeave: () => setHoverIndex(null),
                  })}
                  columns={columns}
                  rowKey={(record) => record.key || record.name}
                  summary={() => (
                    <Table.Summary>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2} align="left">
                          <span>
                            {t("总金额")}：{totalAmount || 0} HKD
                          </span>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  )}
                />

                <Button
                  hidden={isMainFormDisabled}
                  icon={<PlusOutlined />}
                  onClick={() => add()}
                  variant="outlined"
                  color="primary"
                  className={styles.addBtn}
                >
                  {tCommon("新增")}
                </Button>
              </>
            );
          }}
        </Form.List>
      </div>
    </div>
  );
};
